/** Texte und lokales Wegklicken. Welcher Tag welche Saison ist, entscheidet der Server. */

export interface SaisonCopy {
  label: string;
  hinweis: string;
  zeichen: string;
}

export const SAISON_COPY: Record<string, SaisonCopy> = {
  halloween: {
    label: 'Halloween',
    hinweis: 'Nur die Kürbisse sind heute kritisch. Findings bleiben Findings.',
    zeichen: '🎃',
  },
  winter: {
    label: 'Winter',
    hinweis: 'Winterdienst in der Kaffeeküche: heiß und im Scope.',
    zeichen: '❄',
  },
  weihnachten: {
    label: 'Weihnachten',
    hinweis: 'Frohe Weihnachten. Zwischen den Jahren zählen offene Reviews weiter.',
    zeichen: '✶',
  },
  neujahr: {
    label: 'Neujahr',
    hinweis: 'Guten Rutsch. Der Scope gilt auch im neuen Jahr.',
    zeichen: '✶',
  },
  ostern: {
    label: 'Ostern',
    hinweis: 'Frohe Ostern. Eier sind out of scope, Findings nicht.',
    zeichen: '✿',
  },
  pfingsten: {
    label: 'Pfingsten',
    hinweis: 'Pfingsten. Der Kaffeeautomat bleibt im Scope.',
    zeichen: '✿',
  },
  karneval: {
    label: 'Karneval',
    hinweis: 'Helau. Konfetti ändert keinen CVSS.',
    zeichen: '◆',
  },
};

export function saisonDismissStorageKey(userId: number, instanz: string): string {
  return `stark-saison-dismissed:${userId}:${instanz}`;
}

export function isSaisonDismissed(userId: number, instanz: string): boolean {
  try {
    return localStorage.getItem(saisonDismissStorageKey(userId, instanz)) === '1';
  } catch {
    return false;
  }
}

export function dismissSaison(userId: number, instanz: string): void {
  localStorage.setItem(saisonDismissStorageKey(userId, instanz), '1');
}
